import React from 'react';
import Image from 'next/image';
import missionimg from "../../public/images/misson.jpg";
import visionimg from "../../public/images/vision.jpg";
import objectiveimg from "../../public/images/objective.jpg";
import valuesimg from "../../public/images/value.jpg";
import { motion } from 'framer-motion';

const Missionvision = () => {
   return (
      <div className='2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5 mt-10 mb-16'>
         <div className='text-center mt-10 mb-10'>
            <h4 className=' text-[#41b8ea] text-center lg:text-3xl text-base font-bold'>PASSION | COMMITMENT | PROFESSIONALISM</h4>
            <p className='pt-1 lg:text-[25px] tracking-wider lg:px-32'>The secret to EasyCampus's success lies in its foundation of passion, its momentum fueled by commitment, and its stability maintained through professionalism
            </p>
         </div>
         <div className='grid grid-cols-1 lg:grid-cols-4 gap-3'>
            <div>
               <motion.div>
                  <Image src={missionimg} alt='campus recruitment' className=' w-max h-auto' />
               </motion.div>
               <div className='bg-[rgba(240,156,53,0.91)] text-[#fff] p-[22px] mt-3'>
                  <h2 className='text-[#fff]'>Mission</h2>
                  <p  className='text-[18px]'>Our mission is to develop a cutting-edge solution characterized by exceptional quality and steadfast ethics, where talent seamlessly connects with influencers regardless of location.</p>
               </div>
            </div>
            <div>
               <div className='bg-[#45faaec2] p-7'>
                  <h2 className=' '>Vision</h2>
                  <p>To be the premier choice and preferred hub, managing the diverse phases of the campus recruitment supply chain from local to global.</p>
               </div>
               <div>
                  <Image src={visionimg} alt='campus hiring' className='w-full h-auto mt-3' />
               </div>
            </div>
            <div className=''>
               <div>
                  <Image src={objectiveimg} alt='campus recruitment process' className='w-full h-auto ' />
               </div>
               <div className='bg-[#ff5349]  text-[#fff] p-7 mt-3'>
                  <h2 className='text-[#fff]'>Objective</h2>
                  <p>Our goal is to develop a dependable, scalable, and secure solution that facilitates seamless collaboration among multiple stakeholders.</p>
               </div>
            </div>
            <div>
               <div className='bg-[#51b4ffb0] text-[#000] p-7 '>
                  <h2 className=''>Values</h2>
                  <p>We envision the future and strive to deliver long-term value that satisfies all our stakeholders through our dedication and professionalism.</p>
               </div>
               <div>
                  <Image src={valuesimg} alt='automate campus placement' className='w-full h-auto mt-3' />
               </div>
            </div>
         </div>
      </div>
   )
}

export default Missionvision